import Navbar from "./Components/Navbar/Navbar";
import Header from "./Header/Header";
import Services from "./Components/Services/Services";
import Works from "./Components/Works/Works";
// import Footer from "./Components/Footer/Footer";
function App() {
  return (
    <div>
      <Navbar />
      <Header />
      <Services />
      <Works />
      {/* <Footer /> */}
    </div>
  );
};

export default App;
